<template>
  <div class="position_relative d-flex mx-n2" ref="wrap">
    <v-btn
      class="scroll-indicator-order_table_item__toggle"
      @click="toggleRight"
      icon
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <div ref="leftCol" style="width: 50%">
      <div class="px-4">
        <slot name="left" v-if="showLeft"></slot>
      </div>
    </div>
    <div
      v-show="showRight"
      ref="moveIndicator"
      @dblclick="unbindEvents"
      @mousedown="mouseDownIndicatorHandle"
      class="scroll-indicator-order_table"
    >
      <span
        class="d-flex align-center justify-center scroll-indicator-order_table_item"
      >
        <v-icon style="font-size: 14px" color="#C9CDD9">
          mdi-chevron-left
        </v-icon>
        <v-icon style="font-size: 14px" color="#C9CDD9">
          mdi-chevron-right
        </v-icon>
      </span>
    </div>
    <div ref="rightCol" style="width: 50%">
      <div class="px-4" style="height: 100%" v-show="showRight">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_INDICATOR_DATA = {
  offsetWidth: null,
  startX: null,
};

import "./viewer-window.scss";

export default {
  name: "ViewerWindow",
  props: {
    initialLeftWidthInPercent: {
      default: 50,
    },
    minWidthLeftInPx: {
      default: 600,
    },
    minWidthRightInPx: {
      default: 350,
    },
  },
  data() {
    return {
      indicatorData: { ...DEFAULT_INDICATOR_DATA },
      showLeft: true,
      showRight: true,
      dialog: false,
      showOrder: false,
    };
  },
  methods: {
    toggleRight() {
      if (this.showRight) {
        this.hideRight();
      } else {
        this.setSizeToLeftLeft(50);
        this.showRight = true;
      }
    },
    hideRight() {
      this.showRight = false;
      this.setSizeToLeftLeft(100);
    },
    setSizeToLeftLeft(sizeInPercent) {
      const { leftCol, rightCol, moveIndicator } = this.$refs;
      leftCol.style.width = sizeInPercent + "%";
      rightCol.style.width = 100 - sizeInPercent + "%";
      moveIndicator.style.left = sizeInPercent + "%";
    },
    mouseDownIndicatorHandle(e) {
      document.addEventListener("mousemove", this.mouseMoveIndicatorHandle);
      document.addEventListener("mouseup", this.mouseUpIndicatorHandle);
      document.body.style.userSelect = "none";
      const { moveIndicator, wrap } = this.$refs;
      this.indicatorData = {
        offsetWidth: wrap.offsetWidth,
        startX:
          moveIndicator.offsetLeft - 20 + moveIndicator.offsetWidth - e.clientX,
      };
    },
    mouseMoveIndicatorHandle({ clientX }) {
      const { leftCol, rightCol, moveIndicator } = this.$refs;
      const { startX, offsetWidth } = this.indicatorData;
      const position = ((startX + clientX) * 100) / offsetWidth;
      document.body.style.cursor = "col-resize";
      let canMove = position < 95 && position > 5;
      if (
        leftCol.offsetWidth < this.minWidthLeftInPx &&
        this.minWidthLeftInPx > startX + clientX + 50
      ) {
        canMove = false;
      }
      if (
        rightCol.offsetWidth < this.minWidthRightInPx &&
        (this.minWidthRightInPx * 100) / offsetWidth > 100 - position
      ) {
        canMove = false;
      }
      if (canMove) {
        moveIndicator.style.left = position + "%";
        leftCol.style.width = position + "%";
        rightCol.style.width = 100 - position + "%";
      }
    },
    mouseUpIndicatorHandle() {
      this.unbindEvents();
    },
    unbindEvents() {
      document.body.style.userSelect = "initial";
      document.body.style.cursor = "initial";
      document.removeEventListener("mousemove", this.mouseMoveIndicatorHandle);
      document.removeEventListener("mouseup", this.mouseUpIndicatorHandle);
      this.indicatorData = { ...DEFAULT_INDICATOR_DATA };
    },
  },
  mounted() {
    // this.hideRight()
  },
};
</script>
